// extracted by mini-css-extract-plugin
export var firstPage = "pagination-module--firstPage--2e920";
export var isActive = "pagination-module--isActive--35e6c";
export var lastPage = "pagination-module--lastPage--a0023";
export var pageNumber = "pagination-module--pageNumber--d0a92";
export var paginationList = "pagination-module--paginationList--c0e5a";
export var paginationWrapper = "pagination-module--paginationWrapper--0ae2b";
export var prevNext = "pagination-module--prevNext--6aeb0";
export var textLabel = "pagination-module--textLabel--fb723";